export const startEditorText = {
  lifetimeHeading: 'Maximum entries',
  lifetimeDescription: 'How many times can contacts go through this journey in their lifetime?',
  simultaneousHeading: 'Simultaneous entries',
  simultaneousDescription: 'How many times can contacts be in this journey at once?',
  simultaneousGreaterThanLifetimeLimitError:
    'Contacts cannot be in the journey more times than their allowed maximum entries',
  limitSuffix: 'entry',
  limitSuffixPlural: 'entries',
  toggleLabel: 'Use filter',
  triggerHeading: 'Start when',
  multipleJourneysHeading: 'Multiple journeys',
  multipleJourneysDescription:
    'Can a user enter this journey when they are currently in another journey?',
};

export enum LifetimeEntranceLimitType {
  unlimited = 'unlimited',
  custom = 'custom',
  one = 'one',
}

export const lifetimeEntranceLimitTypeOptions = [
  {
    id: LifetimeEntranceLimitType.unlimited,
    value: LifetimeEntranceLimitType.unlimited,
    name: 'Unlimited',
  },
  {
    id: LifetimeEntranceLimitType.one,
    value: LifetimeEntranceLimitType.one,
    name: '1',
  },
  {
    id: LifetimeEntranceLimitType.custom,
    value: LifetimeEntranceLimitType.custom,
    name: 'Other',
  },
];

export enum SimultaneousEntranceLimitType {
  unlimited = 'unlimited',
  one = 'one',
  custom = 'custom',
}

export const simultaneousEntranceLimitTypeOptions = [
  {
    id: SimultaneousEntranceLimitType.one,
    value: SimultaneousEntranceLimitType.one,
    name: 'Contacts must finish this journey before starting this journey again.',
  },
  {
    id: SimultaneousEntranceLimitType.unlimited,
    value: SimultaneousEntranceLimitType.unlimited,
    name: 'Contacts can be in this journey unlimited times simultaneously.',
  },
  {
    id: SimultaneousEntranceLimitType.custom,
    value: SimultaneousEntranceLimitType.custom,
    name: 'Other',
  },
];

export enum ConcurrentJourneyEntranceCriteriaType {
  canEnter = 'canEnter',
  cannotEnter = 'cannotEnter',
  maybeCanEnter = 'maybeCanEnter',
}

export const concurrentJourneyEntranceCriteriaTypeOptions = [
  {
    id: ConcurrentJourneyEntranceCriteriaType.canEnter,
    value: ConcurrentJourneyEntranceCriteriaType.canEnter,
    name: 'Users can enter this journey, even if they are in another journey.',
  },
  {
    id: ConcurrentJourneyEntranceCriteriaType.cannotEnter,
    value: ConcurrentJourneyEntranceCriteriaType.cannotEnter,
    name: `Users can't enter this journey if they are in another journey.`,
  },
  {
    id: ConcurrentJourneyEntranceCriteriaType.maybeCanEnter,
    value: ConcurrentJourneyEntranceCriteriaType.maybeCanEnter,
    name: `Users can't enter this journey if they are in`,
  },
];
